import { PersistedBase64 } from "../models/notice";
import { isIOSSafari } from "./iOS";
import * as Sentry from "@sentry/react";
import { saveAs } from "file-saver";

const fileFormat = (base64: string) => {
  const base64Parts = base64.split(",");

  return base64Parts[0].split(";")[0].split(":")[1];
};

const persistedBlobToISDSFormat = (persistedBlob: PersistedBase64) => {
  const base64Parts = persistedBlob.base64!.split(",");
  return new File([base64Parts[1]], persistedBlob.fileName, {
    type: fileFormat(persistedBlob.base64!),
  });
};

const parseFileNameFromHeaderResponse = (string: string): string | null => {
  const pattern = /filename[^=\n]*=([^\s;]+)/;
  const match = string.match(pattern);

  if (!match) {
    return null;
  }
  return match[1];
};

const createFileFromBlob = (file: any): void => {
  if (!file || !(file.blob instanceof Blob)) {
    return;
  }

  const url = window.URL.createObjectURL(file.blob);
  const a = document.createElement("a");

  a.href = url;
  a.download = file.fileName;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();

  window.URL.revokeObjectURL(url);
};

const saveFileFromURL = async (urlGetter: () => Promise<string | undefined>, sourceIdentifier: string, extra: {}) => {
  const url = await urlGetter();

  if (!url) {
    Sentry.captureException(new Error(`[${sourceIdentifier}] URL to file does not exists`), {
      extra: { url, ...extra },
    });

    return;
  }

  if (isIOSSafari) {
    const a = document.createElement("a");
    a.href = url;
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } else if (!isIOSSafari) {
    const a = document.createElement("a");
    a.href = url;
    a.style.display = "none";
    a.target = "_blank";
    a.setAttribute("download", "");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } else {
    Sentry.captureException(new Error(`[${sourceIdentifier}] - iOS windowReference does not exist`), {
      extra: { url, ...extra },
    });
  }
};

export { persistedBlobToISDSFormat, parseFileNameFromHeaderResponse, saveFileFromURL, fileFormat, createFileFromBlob };
